import React from 'react';

export function Card({ 
  children, 
  variant = 'default',
  padding = 'md',
  shadow = true,
  hover = false,
  className = '',
  ...props 
}) {
  const baseClasses = 'bg-surface border border-border transition-all duration-200';
  
  const variants = {
    default: 'rounded-lg',
    elevated: 'rounded-xl',
    flat: 'rounded-md',
    premium: 'rounded-2xl bg-background'
  };
  
  const paddings = {
    none: 'p-0',
    sm: 'p-3',
    md: 'p-4',
    lg: 'p-6',
    xl: 'p-8'
  };
  
  const shadowClass = shadow ? 'shadow-md' : '';
  const hoverClass = hover ? 'hover:shadow-lg hover:-translate-y-0.5 cursor-pointer' : '';
  const variantClass = variants[variant] || variants.default;
  const paddingClass = paddings[padding] || paddings.md;
  
  return (
    <div
      className={`${baseClasses} ${variantClass} ${paddingClass} ${shadowClass} ${hoverClass} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ children, className = '' }) {
  return (
    <div className={`border-b border-border pb-3 mb-4 ${className}`}>
      {children}
    </div>
  );
}

export function CardBody({ children, className = '' }) {
  return (
    <div className={className}>
      {children}
    </div>
  );
}

export function CardFooter({ children, className = '' }) {
  return (
    <div className={`border-t border-border pt-3 mt-4 ${className}`}>
      {children}
    </div>
  );
}

export default Card;
